import React, { useState } from "react";
import Input from "../Input.jsx";
import Button from "../Button.jsx";

export default function ForgotPassword({ cancelForgotPassword }) {
	const [submitting, updateSubmitting] = useState(false);
	const [email, updateEmail] = useState('');


	function forgotPasswordSubmit(event) {
		event.preventDefault();
		updateSubmitting(true);
	}

	function inputChange(event) {
		updateEmail(event.target.value);
	}

	return (
		<div className='row'>
			<form
				onSubmit={forgotPasswordSubmit}
				method='post'
			>
				<div className='row'>
					<div className='input-field col s12'>
						<Input
							disabled={submitting}
							onChange={inputChange}
							value={email}
							className='validate'
							type='email'
							autoComplete='email'
							id='forgot_email'
						/>
						<label htmlFor='forgot_email'>Enter your email</label>
					</div>
				</div>
				<div className='row'>
					<div className='col s12'>
						<Button
							block
							disabled={true || submitting}
							type='submit'
							name='btn_login'
						>
							Recover My Password (Not Available)
						</Button>
					</div>
				</div>
			</form>
			<div className='row'>
				<div className='col s12'>
					<a
						onClick={cancelForgotPassword}
					>
						Oh wait I remember
					</a>
				</div>
			</div>
		</div>
	);
}